import "@hotwired/turbo-rails"

// deps
import $ from 'jquery'
import { Foundation } from 'foundation-sites'
document.addEventListener('turbo:load', () => $(document).foundation())
import crs from "country-region-selector";

// libs
import "./lib/fontawesome";
import "./lib/ajax";
import "./lib/header_navigation";

// stimulus controllers
import "./controllers"

// init country-region-selector select fields
document.addEventListener('turbo:load', function(e) {
  crs.init();
});

// see config/initializers/pagy.rb for details on lib/pagy.mjs
